import { CladdingMaterial } from "../types/types"
import { genericRequest, claddingMaterialRoute } from "./service"

/**
 * Gets all cladding materials.
 * 
 * @returns A list of cladding materials or an error
 */
export const getCladdingMaterials = async (): Promise<CladdingMaterial[] | Error> => {
  return await genericRequest({ url: `${claddingMaterialRoute}/`, method: "GET" })
}